module.exports = __webpack_public_path__ + "img/3.ba1d7f03.jpg";